<template>
  <el-dialog :title="title" :visible="visible" width="640px" :before-close="handleClose">
    <div class="address_dialog">
      <div class="add_info">
        <span>收货人：</span>
        <el-input v-model="form.consigneeName" placeholder="请使用真实姓名" style="width: 500px"> </el-input>
      </div>
      <div class="add_info">
        <span>手机号：</span>
        <el-input v-model="form.linkMobile" placeholder="收件人手机号" style="width: 500px"> </el-input>
      </div>
      <div class="add_info">
        <span>所在地区：</span>
        <div class="select_address">
          <!-- <div class="select">请选择</div> -->
          <el-cascader
            ref="cascader"
            @change="handleTakeCityChange"
            :options="getAreaTree"
            placeholder="请选择省市区"
            :props="{
              value: 'id',
              label: 'name',
              children: 'childList',
              emitPath: false,
            }"
          ></el-cascader>
        </div>
      </div>
      <div class="add_info">
        <span>详细地址：</span>
        <el-autocomplete
          :disabled="!form.regionName"
          v-model="form.address"
          :fetch-suggestions="querySearchAsync"
          placeholder="请输入详细地址"
          value="location"
          style="width: 500px"
          @select="handleSelect"
        ></el-autocomplete>
        <!-- <el-input v-model="form.address" placeholder="请输入详细地址" style="width: 500px"> </el-input> -->
      </div>
      <div class="add_info">
        <span>设为默认：</span>
        <el-switch
          v-model="form.isDefault"
          :active-value="1"
          :inactive-value="0"
          active-color="#000000"
          inactive-color="#999999"
        >
        </el-switch>
      </div>
    </div>
    <div slot="footer">
      <el-button type="primary" @click="addConserves">保 存</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    info: {
      type: Object,
      default: () => {},
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      getAreaTree: [],
      form: {
        isDefault: 0,
        consigneeName: "",
        linkMobile: "",
        address: "",
        provinceName: "",
        cityName: "",
        regionName: "",
        point: ""
      },
    };
  },
  computed: {},
  created() {},
  async mounted() {
    let { data } = await this.$api.getAreaTree();
    this.getAreaTree = data.childList;
  },
  methods: {
    handleClose(done) {
      this.$emit("update:visible", false);
      done();
    },

    async querySearchAsync(queryString, cb) {
      const params = {
        keyword: queryString,
        key: "VFSBZ-RXV6D-JNN4H-HCSSX-44AIH-MCB44",
        output: "jsonp",
      };
      this.form.cityName && (params.region = this.form.cityName);
      this.$jsonp("https://apis.map.qq.com/ws/place/v1/suggestion", params).then((res) => {
        let result = (res.data || []).map((item) => {
          return {
            label: item.title,
            value: item.title,
            location: item.location,
          };
        });
        cb(result);
      });
    },
    handleSelect(item) {
      console.log(item);
      const { lat, lng } = item.location;
      this.form.point = lat + "," + lng;
    },
    async addConserves() {
      // console.log("this.form", this.form);
      if (this.form.consigneeName == "") {
        this.$message.error("收货人姓名不能为空");
        return;
      }
      if (this.form.linkMobile == "") {
        this.$message.error("收货人手机号不能为空");
        return;
      }
      if (this.form.regionName == "") {
        this.$message.error("省市区不能为空");
        return;
      }
      if (this.form.address == "") {
        this.$message.error("详细地址不能为空");
        return;
      }
      this.$emit("dialogCallback", this.form);
    },
    async handleTakeCityChange(val) {
      let node = this.$refs.cascader.getCheckedNodes();
      this.form.provinceName = node[0].pathLabels[0];
      this.form.cityName = node[0].pathLabels[1];
      this.form.regionName = node[0].pathLabels[2];
    },
  },
  watch: {
    info: {
      handler(val) {
        if (val) {
          this.form = {
            id: val.id ?? '',
            isDefault: val.isDefault ?? 0,
            consigneeName: val.consigneeName ?? "",
            linkMobile: val.linkMobile ?? "",
            address: val.address ?? "",
            provinceName: "",
            cityName: "",
            regionName: "",
          };
        }
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style lang="scss">
.address_dialog {
  .add_info {
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    span {
      display: inline-block;
      width: 72px;
      text-align: right;
    }
    .select_address {
      width: 483px;
      height: 40px;
      border: 1px solid #dcdfe6;
      display: flex;
      align-items: center;
      padding-left: 15px;
      color: #c0c4cc;
      .select {
        width: 80px;
        padding-right: 10px;
      }
      .el-cascader {
        width: 100%;
        .el-input__inner {
          border: 0;
        }
      }
    }
  }
  .add_conserve {
    width: 160px;
    height: 40px;
    border-radius: 6px;
    margin-top: 10px;
  }
}
</style>
